import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette, spacing }) => ({
    switch_label: {
        color: "#000000",
        fontSize: 16,
    },
    ui_switch: {
        marginBottom: ({ gutterBottom }) => (gutterBottom ? spacing(2) : 0),
    },
    "ui_switch__switch_base--checked": {
        "&.Mui-checked": {
            color: ({ color }) => color ? palette[color].main : palette.primary.main,
        },
        "&.Mui-checked+.MuiSwitch-track": {
            backgroundColor: ({ color }) => color ? palette[color].main : palette.primary.main,
        },
    },
}));
//# sourceMappingURL=ui_switch.css.js.map